export default "__VITE_ASSET__ea16c902__"